import core from "@gtmhub/core/module";
import { LookerInsightBuilderComponent } from "./components/looker-insight-builder.component";
import { LookerInsightSelectorService } from "./services/looker-insight-selector-service";

const mod = angular.module("looker", [core]);

mod.service("LookerInsightSelectorService", LookerInsightSelectorService);
mod.component("lookerInsightBuilder", LookerInsightBuilderComponent);

export default mod.name;
